// ╔══════════════════════════════════════════════════════════════╗
// ║  GENIEWORKS WISH FORM — CONFIGURATION                       ║
// ║  Edit this file before deploying. Only file you need to touch║
// ╚══════════════════════════════════════════════════════════════╝

const config = {
  // ── STEP 1: Paste your Apps Script Web App URL here ────────────
  // After deploying the Apps Script (see README.md Step 4-5),
  // copy the Web App URL and paste it below.
  WEBHOOK_URL: "https://script.google.com/macros/s/AKfycbzDqffWwQPxnkwfqdsdDOCiAkz432PIP_fJY2dJUiVJuvJD9G6M0zvSxwwWD50qGvRF/exec",

  // ── STEP 2: Your deployed form URL (for QR generation) ─────────
  // Set this to wherever you host this React app.
  // e.g. "https://wish.genieworks.ai" or "https://genieworks.ai/wish"
  SITE_URL: "https://wish.genieworks.ai",

  // ── Event metadata (cosmetic only) ─────────────────────────────
  EVENT_NAME: "DPW NYC 2026",
  SIGNOFF: "Rajiv + Chris",
  BRAND: "GenieWorks.ai",
};

export default config;
